import  { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllDocuments , updateOneDocument , deleteOneDocument } from "../../redux/actions/documentsActions";
import { useNavigate } from "react-router-dom";
import notify from "../useNotification";

const ViewAllDocumentsHook = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    dispatch(getAllDocuments());
  },[]);

  let allDocuments= useSelector((state) => state.documentsReducer.allDocuments);
  let documents=[]
  if(allDocuments)  documents=allDocuments;
  console.log(documents);

  const clickHandler = (id) => {
    navigate(`/admin/editdocument/${id}`);
  };

  //updateOneCountry
  const handleShowFun = async (id, status) => {
    //console.log(id)
    setLoading(true);
    await dispatch(
        updateOneDocument(id, {
          status: status
        })
      );
  
    setLoading(false);
  };

  // delete documnent
  const deleteDocument=async(id)=>{
    try {
        // setLoading(true);
         // Ask user for confirmation
        const confirmed = window.confirm("هل تريد حذف هذا المستند؟");

    if (!confirmed) {
      // If user clicked "Cancel", stop function here
      return;
    }
        await dispatch(deleteOneDocument(id));
        dispatch(getAllDocuments());
        // setLoading(false);
    } catch (error) {
      
    }
  }

  const res = useSelector((state) => state.documentsReducer.updateDocument);

  useEffect(() => {
    if (loading === false) {
      if (res) {
        notify("تم التعديل بنجاح", "success");
        setTimeout(() => {
          dispatch(getAllDocuments());
        }, 1000);
      } else {
        notify("فشل في عملية التعديل", "error");
      }
    }
  }, [loading]);

  return [documents, clickHandler, handleShowFun,deleteDocument];

  //console.log('first')
}

export default ViewAllDocumentsHook;